import Language from '../../../language/language';

export const signUpStart = () => {
    return {
        type : 'SIGNUP_START'
    }
}

export const signUpSuccess = ()=> {
    return {
        type : 'SIGNUP_SUCCESS'
    }
}

export const signUpFail = (message)=> {
    return {
        type : 'SIGNUP_FAIL',
        payload : {
            message
        }
    }
}

export const signUp = (signUpData) => {
   return (dispatch, getState, getFirebase) => {
       dispatch(signUpStart());

       const { language } = getState().universal;


       const firebase = getFirebase();
       const auth = firebase.auth();
       auth.languageCode = language;
       auth.createUserWithEmailAndPassword(signUpData.email, signUpData.password)
        .then((promise)=>{
            //일단은 회원 등록은 성공했다
            const {email, fullName, address, phone, company, greenhouseType, plantType, areaSize} = signUpData;
            const {uid} = promise.user;
            const userRef = firebase.ref().child(`accounts/${uid}`);
            userRef.set({
                fullName,
                email,
                address,
                phone,
                company,
                greenhouseType,
                plantType,
                areaSize
            })
                .then(()=> {
                    auth.currentUser.sendEmailVerification()
                        .then(() => {
                            dispatch(signUpSuccess());
                        })
                        .catch((e) => {
                            console.log(e);
                        }) 
                })
                .catch((e)=> {
                    console.log(e);
                    dispatch(signUpFail(e));
                })
        })
        .catch( (e)=> {
            const errorCode = e.code;
            let message = '';
            switch(errorCode) {
                case 'auth/email-already-in-use' : {
                    message = Language.signUp.fail.emailAlreadyInUse[language];
                }break;
                case 'auth/invalid-email' : {
                }break;
                case 'auth/operation-not-allowed' : {
                }break;
                case 'auth/weak-password' : {
                }break;
            }
            dispatch(signUpFail(message));
        })

   } 
}


// WEBPACK FOOTER //
// ./src/components/SignUp/actions/signUpActions.js